import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-inline" }
const _hoisted_2 = { class: "measures px-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", { class: "text-center font-weight-bold my-4" }, "Guía de medidas", -1)
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  class: "nav nav-tabs nav-justified",
  id: "myTab",
  role: "tablist"
}
const _hoisted_6 = ["id", "href", "aria-controls", "onClick"]
const _hoisted_7 = { class: "tab-content pt-3" }
const _hoisted_8 = ["id", "aria-labelledby"]
const _hoisted_9 = { class: "col text-left font-weight-bold py-2" }
const _hoisted_10 = {
  key: 0,
  class: "col py-2 text-right"
}
const _hoisted_11 = { class: "text-center mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mdb_modal_body = _resolveComponent("mdb-modal-body")!
  const _component_mdb_modal = _resolveComponent("mdb-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.product.garment)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modal = true)),
          class: "btn btn-md btn-link"
        }, "Guía de medidas"))
      : _createCommentVNode("", true),
    (_ctx.product.garment)
      ? (_openBlock(), _createBlock(_component_mdb_modal, {
          key: 1,
          size: "md",
          show: _ctx.modal,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.modal = false))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_mdb_modal_body, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _hoisted_3,
                  _createElementVNode("img", {
                    class: "w-100 mb-3",
                    src: this.$siteUrl + _ctx.product.garment.image
                  }, null, 8, _hoisted_4),
                  _createElementVNode("ul", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.presentations, (presentation, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: presentation.id,
                        class: "nav-item"
                      }, [
                        _createElementVNode("a", {
                          class: _normalizeClass(["nav-link", (index === _ctx.tabMeasureSelected)? 'active' : '']),
                          id: presentation.id + '-tab',
                          href: '#tab_' + presentation.id,
                          "aria-controls": 'tab_' + presentation.id,
                          onClick: ($event: any) => (_ctx.tabMeasureSelected = index),
                          "data-toggle": "tab",
                          role: "tab",
                          "aria-selected": "true"
                        }, _toDisplayString(presentation.name), 11, _hoisted_6)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.presentations, (presentation, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        role: "tabpanel",
                        class: _normalizeClass(["tab-pane fade container", (index === _ctx.tabMeasureSelected)? 'show active' : '']),
                        key: presentation.id,
                        id: 'tab-' + presentation.id,
                        "aria-labelledby": presentation.id + '-tab'
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.garment.measures, (row) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: row.id,
                            class: "row border-bottom"
                          }, [
                            _createElementVNode("div", _hoisted_9, _toDisplayString(row.name), 1),
                            (_ctx.product.garment.values[presentation.id] && _ctx.product.garment.values[presentation.id][row.id])
                              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.product.garment.values[presentation.id][row.id]) + " cm.", 1))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ], 10, _hoisted_8))
                    }), 128))
                  ])
                ]),
                _createElementVNode("p", _hoisted_11, [
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    type: "button",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modal = false))
                  }, "CERRAR")
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["show"]))
      : _createCommentVNode("", true)
  ]))
}